import { Injectable } from '@angular/core';
import { ResponseService, ValidaRubroDTO } from '../types/type';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { catchError, retry, throwError } from 'rxjs';
import { Utilerias } from '../helpers/Utilerias';

enum methods {
  PostValidaRubro = 'PostValidaRubro',
}

@Injectable({
  providedIn: 'root'
})
export class RubroService {
  headers: HttpHeaders;
  URL: string

  constructor(private http: HttpClient) {
    this.URL = environment.urlService
    this.headers = new HttpHeaders();
    if (localStorage?.jwt) {
      this.headers = new HttpHeaders({
        'Authorization': localStorage.jwt
      })
    }
  }

  postValidaRubro(body: ValidaRubroDTO) {
    return this.http.post<ResponseService>(`${this.URL}${methods.PostValidaRubro}`, body, {
      headers: this.headers
    })
      .pipe(
        retry(1),
        catchError(this.handleError)
      )
  }

  private handleError(error: HttpErrorResponse) {
    console.log('Error en Usuarios Service' + error.message);
    Utilerias.alertClient('Error al hacer la petición', 'Intente de nuevo', 1);
    if (error.status === HttpStatusCode.Unauthorized) {
      Utilerias.closeSesion(this.http);
      return throwError(() => new Error('!Error Unauthorized, verifique sus credenciales!'))
    }
    return throwError(() => new Error('!Fuera de servicio, intente nuevamente!'))
  }
}
